import { render, staticRenderFns } from "./MdmCheckbox.vue?vue&type=template&id=04c736ea&scoped=true&name=mdm-checkbox&"
import script from "./MdmCheckbox.vue?vue&type=script&lang=js&"
export * from "./MdmCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./MdmCheckbox.vue?vue&type=style&index=0&id=04c736ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c736ea",
  null
  
)

export default component.exports